const styles = () => ({
  root: {
    overflow: 'hidden',
    borderRadius: '50%',
    flex: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  image: {
    display: 'block',
    width: '100%',
  },

  companyDefault: {
    backgroundColor: '#efeef9',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '8%',
  },
});

export default styles;
